var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenTrashCan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    strokeLinejoin: "miter",
    stroke: "#1a6ac9",
    strokeWidth: 35.3586,
    fill: "none",
    d: "M598.657+123.726L343.124+218.37L337.673+203.654C327.551+176.325+351.706+143.472+393.23+128.092L505.026+86.6853C543.356+72.4886+583.084+81.6805+593.207+109.01L598.657+123.726Z",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.781+282.717C138.353+260.45+194.406+236.565+194.406+236.565C196.025+235.916+198.705+234.899+200.385+234.278L717.996+43.0428C719.675+42.4222+726.313+39.8043+723.947+40.7274C723.947+40.7274+777.861+20.5361+806.411+27.0783C833.974+33.3944+852.702+69.4259+852.702+69.4259C853.428+71.0497+852.616+72.8866+850.937+73.5086L118.999+344.604C117.32+345.226+115.331+341.148+115.484+342.58C115.484+342.58+111.807+304.003+124.781+282.717Z",
    fill: "#24a8ec",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.143+296.202C161.143+296.202+180.333+653.908+201.994+813.558C223.655+973.209+213.343+965.186+247.723+965.186C247.723+965.186+726.779+968.526+756.41+968.862C786.042+969.197+786.752+976.107+810.912+807.942C830.156+673.993+845.477+428.749+850.915+334.499C852.305+310.425+851.197+306.944+846.049+301.202C841.844+296.512+824.994+296.326+815.642+296.367",
    fill: "#24a8ec",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a6ac9",
    opacity: 1,
    d: "M455.545+882.549L455.331+882.549C449.456+882.549+444.484+877.792+444.224+871.923L423.676+407.365C423.417+401.497+427.968+396.739+433.843+396.739L455.545+396.739C461.42+396.739+466.182+401.501+466.182+407.376L466.182+871.913C466.182+877.787+461.42+882.549+455.545+882.549Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M554.622+882.549L554.407+882.549C548.532+882.549+543.77+877.787+543.77+871.913L543.77+407.376C543.77+401.501+548.532+396.739+554.407+396.739L576.109+396.739C581.984+396.739+586.535+401.497+586.276+407.365L565.728+871.923C565.469+877.792+560.496+882.549+554.622+882.549Z",
    fill: "#1a6ac9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M664.462+882.549L664.206+882.549C657.211+882.549+651.839+876.887+652.207+869.901L676.462+409.388C676.83+402.402+682.799+396.739+689.794+396.739L707.438+396.739C714.433+396.739+719.604+402.388+718.987+409.356L678.244+869.933C677.628+876.901+671.457+882.549+664.462+882.549Z",
    fill: "#1a6ac9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a6ac9",
    d: "M345.741+882.549L345.495+882.549C338.773+882.549+332.844+877.121+332.251+870.426L291.421+408.863C290.829+402.167+295.798+396.739+302.52+396.739L321.153+396.739C327.875+396.739+333.599+402.182+333.939+408.895L357.297+870.394C357.637+877.107+352.463+882.549+345.741+882.549Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.48+340.322L847.718+70.967C851.518+69.5597+855.74+71.4991+857.147+75.2989L857.147+75.2989C858.554+79.0987+856.615+83.3199+852.815+84.7273L125.576+354.082C121.777+355.489+117.555+353.55+116.148+349.75L116.148+349.75C114.741+345.95+116.68+341.729+120.48+340.322Z",
    opacity: 1,
    fill: "#1a6ac9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.955+955.92L778.236+955.92C782.124+955.92+785.276+959.072+785.276+962.96L785.276+962.96C785.276+966.848+782.124+970+778.236+970L229.955+970C226.067+970+222.915+966.848+222.915+962.96L222.915+962.96C222.915+959.072+226.067+955.92+229.955+955.92Z",
    opacity: 1,
    fill: "#1a6ac9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#000a91",
    d: "M507.096+374.33L507.096+374.33L507.096+377.368L507.096+377.368L507.096+374.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M506.716+287.786L507.476+287.786L507.476+287.786L506.716+287.786Z",
    fill: "#000a91"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M507.096+395.596L507.096+395.596L507.096+397.115L507.096+397.115L507.096+395.596Z",
    fill: "#000a91"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#000a91",
    d: "M507.096+284.857L507.096+284.857L507.096+287.786L507.096+287.786L507.096+284.857Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000a91",
    d: "M507.096+284.857L507.096+284.857L507.096+287.786L507.096+287.786L507.096+284.857Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.096+535.978L507.096+535.978L507.096+537.497L507.096+537.497L507.096+535.978Z",
    opacity: 1,
    fill: "#000a91"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenTrashCan);
export default __webpack_public_path__ + "static/media/OpenTrashCan.63de4b4f3a94d8f0fa9f4c0a5614382b.svg";
export { ForwardRef as ReactComponent };